<template lang="pug">
  .card
    .card-body
      h4.card-title.text-center.d-flex.justify-content-between
        i.fa.fa-chevron-left(@click.prevent="prev()")
        span Other Products and Services
        i.fa.fa-chevron-right(@click.prevent="next()")
      hr
      .row
        .col-md-8
          ValidationObserver(ref="Validation" slim)
            //- ValidationProvider(name="agreement" rules="required" v-slot="{error}" slim)
            .form-group
              label Please click product included on your Membership Package
            .custom-control.custom-checkbox(v-for="(value, name, index) in productAndServices", :key="'products-services-'+index")
              input.custom-control-input#produc_and_services1(:id="'produc_and_services_'+index", type="checkbox", name="produc_and_services", :value="name")
              label.custom-control-label(:for="'produc_and_services_'+index") {{value}}
              //- .custom-control.custom-checkbox
                input.custom-control-input#produc_and_services2(type="checkbox" name="produc_and_services" value="KAYA_PAYMENT_PLATFORM")
                label.custom-control-label(for="produc_and_services2") KAYA PAYMENT PLATFORM
              //- .custom-control.custom-checkbox
                input.custom-control-input#produc_and_services2(type="checkbox" name="produc_and_services" value="KAYA_PAYMENT_PLATFORM")
                label.custom-control-label(for="produc_and_services2") MMC_MOBILE_APPLICATION
</template>

<style scoped=""></style>

<script>
  import { ref, reactive } from '@vue/composition-api'
  
  export default {
    name: 'step_4',
    props: {
      // config: {
      //   type: Object,
      //   required: true,
      // }
    },
    emits: ['prev', 'next'],

    setup(props, {emit}) {
      const Validation = ref(null)
      const productAndServices = reactive({
        'PINOY_KOOP_ATM_SERVICE': 'PINOY KOOP ATM SERVICE',
        'KAYA_PAYMENT_PLATFORM': 'KAYA PAYMENT PLATFORM',
        'MMC_MOBILE_APPLICATION': 'MMC MOBILE APPLICATION',
        'INSURANCE_(AKSI,GLAFFLETC)': 'INSURANCE (AKSI,GLAFFLETC)',
      })
      const prev = () => {
        emit('prev');
      }
      const next = () => {
        emit('next');
      }
      return {
        productAndServices,
        Validation, prev, next,
      }
    }
  }
</script>